import React, { useState, useRef, useEffect } from 'react';
import 'primereact/resources/themes/lara-light-blue/theme.css'
import '../../styles/global.css';
import '../../styles/pages/CadastroFarm.css';
import '@geoman-io/leaflet-geoman-free'
import { Dropdown } from 'primereact/dropdown';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import EventIcon from '@mui/icons-material/Event';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PestControlIcon from '@mui/icons-material/PestControl';
import SwipeDownIcon from '@mui/icons-material/SwipeDown';
import ScienceIcon from '@mui/icons-material/Science';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import { Column } from 'primereact/column';
import Cookies from 'js-cookie';
import API from '../../api/API'
import { DataTable } from 'primereact/datatable';
import { ControleType, PlantioType, newControle, PlanoType, ImovelType, CONTROLTYPE } from '../../db/Orm';
import MedicationIcon from '@mui/icons-material/Medication';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Divider } from 'primereact/divider';
import { PiPlantFill } from "react-icons/pi";
import { MdMap } from "react-icons/md";
import { IoIosBug } from "react-icons/io";
import { Accordion, AccordionTab, AccordionTabChangeEvent } from 'primereact/accordion';
import { Badge } from 'primereact/badge';
import { FaVirus } from "react-icons/fa";
import { ProgressSpinner } from 'primereact/progressspinner';
import { LotesSelect } from '../components/LotesSelect';
import axios, { AxiosResponse } from 'axios';
import Embrapa from '../../api/Embrapa';

type CadastroControlesProps = {
    propriedades: Array<ImovelType>
    visible: boolean
    setVisible: Function
    edit?: boolean
}

export default function CadastroControles(props: CadastroControlesProps) {
    const [controlePragas, setControlePragas] = useState<ControleType>(newControle())
    const [controlesPragas, setControlesPragas] = useState<Array<ControleType>>([])
    const [controleDoencas, setControleDoencas] = useState<ControleType>(newControle())
    const [controlesDoencas, setControlesDoencas] = useState<Array<ControleType>>([])
    const [planos, setPlanos] = useState<Array<PlanoType>>([]);
    const [plantios, setPlantios] = useState<Array<PlantioType>>([]);
    const [plano, setPlano] = useState<PlanoType | null>();
    const [plantio, setPlantio] = useState<PlantioType | null>(null);
    const msgs = useRef<any>(null);

    const [fabricantes, setFabricantes] = useState<Array<any>>([])
    const [produtosBiologicosDataSet, setProdutosBiologicosDataSet] = useState<Array<any>>([])
    const toast = useRef<Toast | null>(null);
    const [filteredFabricantes, setFilteredFabricantes] = useState<Array<any>>([])
    const [accordionIndex, setAccordionIndex] = useState<AccordionTabChangeEvent["index"]>()

    useEffect(() => {
        if (plantio?.cultura) {
            carregarProdutosBiologicos()
        }
    }, [plantio?.cultura])
    const carregarProdutosBiologicos = async () => {
        //console.log('Carregando Produtos Biologicos')
        const apikey = Embrapa.keys.bioinsumos
        var url = Embrapa.urls.bioinsumos_produtos
        url += `&cultura=${plantio?.cultura.normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`
        // if (controlePragas.fabricante?.name)
        // url += `&titular_registro=${controlePragas.fabricante.name.split('-')[0].trim().replace(' ', '%20')}`
        url += `&page=1`
        const json = await Embrapa.fetchOrLoad(url, apikey)
        //console.log(json)
        const dados = json.map((c: any, index: number) => { return { name: `${c.numero_registro} - ${c.marca_comercial[0]}`, code: c.numero_registro, object: c } })
        setProdutosBiologicosDataSet(dados)
        setFabricantes(Array.from(new Set(json.map((produtos: any) => produtos.titular_registro))).sort().map((fabricante) => { return fabricante }))
        console.log('ProdutosBiologicos', dados)
    }

    function changeFieldControlePraga(event: any) {
        const { value, name } = event.target;
        //console.log('ChangeField', name, value)
        setControlePragas({ ...controlePragas, [name]: value });
    }
    const genInvalidMessageDose = (inputValue: string) => {
        if (!(/^\d+([.,]\d+)?$/).test(inputValue)) return 'Valor inválido'
        if (!(/[A-Za-z]\w*(\/\w+)?$/).test(inputValue)) return 'Insira a unidade: Kg, L, Kg/ha, L/ha...'
        return ''
    }
    const onInputDosePragas = (event: React.FormEvent<HTMLInputElement>, validateOnly: boolean) => {
        //console.log(event, validateOnly)
        invalidDosePragas === validateOnly && setInvalidDosePragas(!validateOnly)
        if (validateOnly) return
        setInvalidMessageDosePragas(genInvalidMessageDose(event.currentTarget.value))
    }
    const onInputDoseDoenca = (event: React.FormEvent<HTMLInputElement>, validateOnly: boolean) => {
        invalidDoseDoenca === validateOnly && setInvalidDoseDoenca(!validateOnly)
        if (validateOnly) return
        setInvalidMessageDoseDoenca(genInvalidMessageDose(event.currentTarget.value))
    }
    function changeFieldControleDoenca(event: any) {
        const { value, name } = event.target;
        //console.log('ChangeField', name, value)
        setControleDoencas({ ...controleDoencas, [name]: value });
    }
    const addControlePragas = () => {
        setControlesPragas([...controlesPragas, controlePragas])
        setControlePragas(newControle())
        refreshPragas()
    }
    const refreshPragas = () => {
        const currentIndex = accordionIndex
        setAccordionIndex(undefined)
        setTimeout(() => { setAccordionIndex(currentIndex) }, 500)
    }
    const addControleDoencas = () => {
        controlesDoencas.push(controleDoencas)
        setControleDoencas(newControle())
    }
    const resetarCampos = () => {
        // setPlano(null)
        // setPlantio(null)
        setControlesPragas([])
        setControlesDoencas([])
    }
    async function cadastrar(event: React.FormEvent) {
        event.preventDefault();
        setWaiting(true)
        
        controlesPragas.forEach((controle) => {
            controle.tipo = CONTROLTYPE.PESTS
            controle.plantio = plantio
        })
        controlesDoencas.forEach((controle) => {
            controle.tipo = CONTROLTYPE.DISEASES
            controle.plantio = plantio
        })
        
        try {
            const controles = controlesPragas.concat(controlesDoencas);
            const contResponse = await cadastrarControles(controles);
            console.log('Controles Response:', contResponse);
            resetarCampos();
            toast.current?.show({severity: 'success',summary: 'Cadastro de Controles',detail: 'Cadastro bem-sucedido'});
        } catch (error: any) {
            console.log(error); // O erro agora terá os detalhes
            toast.current?.show({severity: 'error',summary: 'Erro no Cadastro',detail: error.message,life: 6000 });
        }
        setWaiting(false)
    }
    const cadastrarControle = (controle: ControleType) => {
        const form = new FormData()
        controle.tipo && form.append('tipo', controle.tipo)
        controle.plantio && form.append('plantio', controle.plantio.id)
        controle.nome && form.append('nome', controle.nome)
        controle.fabricante && form.append('fabricante', controle.fabricante)
        controle.produto && form.append('produto', controle.produto)
        controle.aplicacao && form.append('aplicacao', controle.aplicacao)
        controle.dose && form.append('dose', controle.dose)
        controle.epoca && form.append('epoca', controle.epoca)
        return axios.post(API.url + 'controles/', form, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
    }
    const cadastrarControles = async (controles: Array<ControleType>) => {
        const responses: Array<AxiosResponse> = [];

        // Usamos um for...of com índice para saber qual controle falhou
        for (const [index, cont] of controles.entries()) {
            try {
                const resp = await cadastrarControle(cont);
                resp && responses.push(resp);
            } catch (error: any) {
                // Verificamos se o erro é do Axios e se tem uma resposta do servidor
                if (axios.isAxiosError(error) && error.response) {
                    console.error('Erro na API:', error.response.data);
                    // Monta uma mensagem de erro detalhada
                    const detalhes = JSON.stringify(error.response.data, null, 2);
                    throw new Error(`Erro ao cadastrar o controle #${index + 1}: ${detalhes}`);
                } else {
                    // Caso seja um erro genérico (rede, etc.)
                    console.error('Erro inesperado:', error);
                    throw new Error(`Erro inesperado ao cadastrar o controle #${index + 1}: ${error.message}`);
                }
            }
        }
        return responses
    }


    const headerElement = (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <PiPlantFill />
            <span style={{ marginLeft: 10, marginRight: 10, width: '100%' }}>Cadastro de Controles</span>
        </div>
    )

    const fabricanteTemplate = (item: any) => {
        return (<div style={{ color: 'black' }}>{item}</div>);
    };
    useEffect(() => {
        setFilteredFabricantes(fabricantes)
    }, [fabricantes])
    const search = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            let _filteredFabricantes;
            if (!event.query.trim().length) {
                _filteredFabricantes = [...fabricantes];
            }
            else {
                _filteredFabricantes = fabricantes.filter((fabricante) => {
                    return fabricante.toLowerCase().includes(event.query.toLowerCase());
                });
            }
            setFilteredFabricantes(_filteredFabricantes);
        }, 250);
    }
    const [filteredPragas, setFilteredPragas] = useState<Array<string>>([])
    const [filteredProdutosPragas, setFilteredProdutosPragas] = useState<Array<string>>([])
    const [filteredAplicacao, setFilteredAplicacao] = useState<Array<string>>([])
    const searchProdutosPragas = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            const produtosDS = produtosBiologicosDataSet.filter(v => v.object.titular_registro === controlePragas.fabricante)
            const produtosNomes = produtosDS.map(v => v.object.marca_comercial[0]) as Array<string>
            const filteredNames = produtosNomes.filter(v => v.toLowerCase().includes(event.query.toLowerCase()))
            setFilteredProdutosPragas(filteredNames)
        }, 500)
        return
    }
    const searchPragas = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            const produtoSelecionado = produtosBiologicosDataSet.filter((produto) => controlePragas.produto === produto.object.marca_comercial[0])[0]
            if (!produtoSelecionado) return setFilteredPragas([])
            const indicacoes: Array<any> = produtoSelecionado.object.indicacao_uso.filter((indi: any) => indi.cultura.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase() === plantio?.cultura || indi.cultura === 'Todas as culturas')
            const uniquePragas: Set<string> = new Set()
            indicacoes.forEach((i) => { uniquePragas.add(i.praga_nome_cientifico) })
            let _pragas = Array.from(uniquePragas)
            _pragas = _pragas.filter(p => p.includes(event.query))
            setFilteredPragas(_pragas)
        }, 500)
    }
    const searchAplicacao = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            const produtoSelecionado = produtosBiologicosDataSet.filter((produto) => controlePragas.produto === produto.object.marca_comercial[0])[0]
            if (!produtoSelecionado) return setFilteredPragas([])
            let _aplicacoes: Array<string> = produtoSelecionado.object.tecnica_aplicacao
            _aplicacoes = _aplicacoes.filter(apli => apli.includes(event.query))
            setFilteredAplicacao(_aplicacoes)
        }, 500)
    }
    const getPlanosFromPropriedade = async (id: number) => {
        const request = await axios.get(API.url + 'planos/?propriedade=' + id, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
        if (request.status !== 200) {
            throw new Error('Falha ao obter planos')
        }
        const planos = request.data as Array<PlanoType>
        //console.log('Planos:', planos)
        return planos
    }

    const loadPlanos = async (propriedade: ImovelType) => {
        setPlano(null)
        setPlantio(null)
        setLabelPlano('Carregando planos')
        setLabelPlantio('Selecione o plano')
        setDisablePlantio(true)
        const opcoes: Array<any> = [];
        (await getPlanosFromPropriedade(propriedade.id)).forEach((plano: PlanoType) => {
            if (!plano.responsavel_tecnico){return}
            opcoes.push({
                ...plano,
                label: `${plano.id} | ${plano.responsavel_tecnico.pessoa.nome_razao} `, // | ${plantio.cultura} - ${plantio.variedade}`,
            })
        })
        setPlanos(opcoes)
        setDisablePlano(false)
        setLabelPlano('Selecione o plano')
    }
    const loadPlantios = async (plano: PlanoType) => {
        setPlantios(plano.plantios?.map((plantio: PlantioType) => {
            return { ...plantio, label: `${plantio.id} | ${plantio.data && (new Date(plantio.data).toLocaleDateString())} | ${plantio.cultura} - ${plantio.variedade}` }
        }) || [])
    }
    const changeFieldPlano = (e: any) => {
        setPlano(e.value)
        setLabelPlantio('Selecione o plantio')
        setDisablePlantio(false)
        loadPlantios(e.value)
    }
    const changeFieldPlantio = (e: any) => {
        setPlantio(e.value)
    }
    const deletePragaTemplate = (item: any) => {
        return <Button severity="danger" icon="pi pi-times" rounded onClick={() => { deletePraga(item) }}></Button>
    }
    const deletePraga = (item: any) => {
        setControlesPragas(controlesPragas.filter(p => p !== item))
    }
    const deleteDoencaTemplate = (item: any) => {
        return <Button severity="danger" icon="pi pi-times" rounded onClick={() => { deleteDoenca(item) }}></Button>
    }
    const deleteDoenca = (item: any) => {
        setControlesDoencas(controlesDoencas.filter(p => p !== item))
    }

    const [waiting, setWaiting] = useState<boolean>(false)
    const [labelPlano, setLabelPlano] = useState<string>('Informe a Propriedade')
    const [labelPlantio, setLabelPlantio] = useState<string>('Informe a Propriedade')
    const [disablePlano, setDisablePlano] = useState<boolean>(true)
    const [disablePlantio, setDisablePlantio] = useState<boolean>(true)

    const [invalidDosePragas, setInvalidDosePragas] = useState<boolean>(false)
    const [invalidMessageDosePragas, setInvalidMessageDosePragas] = useState<string>('')
    const [invalidDoseDoenca, setInvalidDoseDoenca] = useState<boolean>(false)
    const [invalidMessageDoseDoenca, setInvalidMessageDoseDoenca] = useState<string>('')
    return (
        <Dialog visible={props.visible} header={headerElement} maximizable style={{ width: '1000px' }} onHide={() => { props.setVisible(false) }} resizable position={'center'} modal>
            <Messages ref={msgs} style={{ position: 'fixed', bottom: 20, right: 280 }} />
            <ConfirmDialog />
            <Toast ref={toast} position="bottom-right" />
            <ScrollPanel style={{ width: '100%', height: '100%' }} >
                <Divider align='left'>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <MdMap style={{ marginRight: 5 }} />
                        <b>Lotes</b>
                    </div>
                </Divider>
                <div style={{ height: 5 }} />
                <LotesSelect propriedades={props.propriedades} lotes={[]} setCount={(value: number) => { return }} setPropriedade={async (propriedade: ImovelType) => { await loadPlanos(propriedade) }} />
                <div style={{ height: 5 }} />
                <div className="flex flex-column p-inputgroup flex-1">
                    <span className="p-inputgroup-addon"><b> Plano</b></span>
                    <span className="p-float-label">
                        <Dropdown disabled={disablePlano || (controlesDoencas.length + controlesPragas.length !== 0)} name='plano' value={plano} onChange={changeFieldPlano} options={planos} optionLabel="label" filter />
                        <label htmlFor="plano">{labelPlano}</label>
                    </span>
                </div>
                <div style={{ height: 5 }} />
                <div className="flex flex-column p-inputgroup flex-1">
                    <span className="p-inputgroup-addon"><b> Plantio</b></span>
                    <span className="p-float-label">
                        <Dropdown disabled={disablePlantio || (controlesDoencas.length + controlesPragas.length !== 0)} name='plantio' value={plantio} onChange={changeFieldPlantio} options={plantios} optionLabel={'label'} filter />
                        <label htmlFor="plantio">{labelPlantio}</label>
                    </span>
                </div>
                <div style={{ height: 5 }} />
                <Accordion activeIndex={accordionIndex} onTabChange={(e) => { setAccordionIndex(e.index) }}>
                    <AccordionTab
                        header={
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <IoIosBug style={{ marginRight: 5 }} />
                                <b>Controle de Pragas</b>
                                {controlesPragas.length > 0 && <Badge style={{ marginLeft: 5 }} value={controlesPragas.length} />}
                            </div>
                        }>
                        <div className="flex flex-column p-inputgroup flex-1">

                            <span className="p-inputgroup-addon"><MedicationIcon /><b> Fabricante</b></span>
                            <span className="p-float-label">
                                <AutoComplete name='fabricante' field="fabricante" value={controlePragas.fabricante} suggestions={filteredFabricantes} completeMethod={search} onChange={changeFieldControlePraga} itemTemplate={fabricanteTemplate} dropdown />
                                <label htmlFor="fabricante">Informe o fabricante</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">

                            <span className="p-inputgroup-addon"><MedicationIcon /><b> Produto Comercial</b></span>
                            <span className="p-float-label">
                                <AutoComplete name='produto' field="produto" value={controlePragas.produto} suggestions={filteredProdutosPragas} completeMethod={searchProdutosPragas} onChange={changeFieldControlePraga} itemTemplate={fabricanteTemplate} dropdown />
                                <label htmlFor="produto">Informe o produto comercial</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><PestControlIcon /><b> Praga</b></span>
                            <span className="p-float-label">
                                <AutoComplete name='nome' field='nome' value={controlePragas.nome ? controlePragas.nome : ''} onChange={changeFieldControlePraga} suggestions={filteredPragas} completeMethod={searchPragas} itemTemplate={fabricanteTemplate} dropdown />
                                <label htmlFor="nome">Informe o nome da praga</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><SwipeDownIcon /><b> Aplicação</b></span>
                            <span className="p-float-label">
                                <AutoComplete name='aplicacao' field='aplicacao' value={controlePragas.aplicacao ? controlePragas.aplicacao : ''} onChange={changeFieldControlePraga} suggestions={filteredAplicacao} completeMethod={searchAplicacao} itemTemplate={fabricanteTemplate} dropdown></AutoComplete>
                                <label htmlFor="aplicacao">Informe a metodologia de aplicação</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><ScienceIcon /><b> Dose</b></span>
                            <span className="p-float-label">
                                <InputText name='dose' value={controlePragas.dose || ''} onChange={changeFieldControlePraga} validateOnly keyfilter={/^\d+([.,]\d+)?[A-Za-z]\w*(\/\w+)?$/} onInput={onInputDosePragas} style={{ backgroundColor: invalidDosePragas ? '#ff8a80' : undefined }} />
                                <label htmlFor="dose">Informe a quantidade do insumo aplicado.</label>
                            </span>
                        </div>
                        {invalidDosePragas && <small style={{ paddingLeft: '6rem' }}>{invalidMessageDosePragas}</small>}
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><EventIcon ></EventIcon> <b>Época</b></span>
                            <span className="p-float-label">
                                <InputText name='epoca' value={controlePragas.epoca || ''} onChange={changeFieldControlePraga} />
                                <label htmlFor="epoca">Informe o quando será aplicado</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />

                        <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                            <Button icon={<AddCircleIcon />} onClick={addControlePragas}> <b>Adicionar</b></Button>
                        </div>

                        <div style={{ height: 5 }} />
                        <DataTable value={controlesPragas} tableStyle={{ minWidth: '50rem' }}>
                            <Column header="Praga" field='nome' ></Column>
                            <Column header="Produto" field='produto'></Column>
                            <Column header="Aplicação" field='aplicacao'></Column>
                            <Column header="Dose" field='dose' ></Column>
                            <Column header="Época" field='epoca'></Column>
                            <Column body={deletePragaTemplate} exportable={false}></Column>
                        </DataTable>
                    </AccordionTab>
                    <AccordionTab
                        header={
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <FaVirus style={{ marginRight: 5 }} />
                                <b>Controle de Doenças</b>
                                {controlesDoencas.length > 0 && <Badge style={{ marginLeft: 5 }} value={controlesDoencas.length} />}
                            </div>
                        }>
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><CoronavirusIcon /><b> Doença</b></span>
                            <span className="p-float-label">
                                <InputText name='nome' value={controleDoencas.nome || ''} onChange={changeFieldControleDoenca} />
                                <label htmlFor="nome">Informe o nome da doença</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><MedicationIcon /><b> Produto</b></span>
                            <span className="p-float-label">
                                <InputText name='produto' value={controleDoencas.produto || ''} onChange={changeFieldControleDoenca} />
                                <label htmlFor="produto">Informe o produto comercial</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><SwipeDownIcon /><b> Aplicação</b></span>
                            <span className="p-float-label">
                                <InputText name='aplicacao' value={controleDoencas.aplicacao || ''} onChange={changeFieldControleDoenca} />
                                <label htmlFor="aplicacao">Informe a metodologia de aplicação</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><ScienceIcon /><b> Dose</b></span>
                            <span className="p-float-label">
                                <InputText name='dose' value={controleDoencas.dose || ''} onChange={changeFieldControleDoenca} validateOnly keyfilter={/^\d+([.,]\d+)?[A-Za-z]\w*(\/\w+)?$/} onInput={onInputDoseDoenca} style={{ backgroundColor: invalidDoseDoenca ? '#ff8a80' : undefined }} />
                                <label htmlFor="dose">Informe a quantidade do insumo aplicado</label>
                            </span>
                        </div>
                        {invalidDoseDoenca && <small style={{ paddingLeft: '6rem' }}>{invalidMessageDoseDoenca}</small>}
                        <div style={{ height: 5 }} />
                        <div className="flex flex-column p-inputgroup flex-1">
                            <span className="p-inputgroup-addon"><EventIcon ></EventIcon> <b>Época</b></span>
                            <span className="p-float-label">
                                <InputText name='epoca' value={controleDoencas.epoca || ''} onChange={changeFieldControleDoenca} />
                                <label htmlFor="epoca">Informe o quando será aplicado</label>
                            </span>
                        </div>
                        <div style={{ height: 5 }} />

                        <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                            <Button icon={<AddCircleIcon />} onClick={addControleDoencas}> <b>Adicionar</b></Button>
                        </div>

                        <div style={{ height: 5 }} />
                        <DataTable value={controlesDoencas} tableStyle={{ minWidth: '50rem' }}>
                            <Column header="Doença" field='nome' ></Column>
                            <Column header="Produto" field='produto'></Column>
                            <Column header="Aplicação" field='aplicacao'></Column>
                            <Column header="Dose" field='dose' ></Column>
                            <Column header="Época" field='epoca'></Column>
                            <Column body={deleteDoencaTemplate} exportable={false}></Column>
                        </DataTable>
                    </AccordionTab>

                </Accordion>

                <Button label={waiting ? '' : 'CADASTRAR'} icon={waiting ? '' : 'pi pi-send'}
                    iconPos='right' severity="success" rounded onClick={cadastrar}
                    disabled={waiting || !(plantio && controlesDoencas.length + controlesPragas.length)} >{waiting && <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />}</Button>
            </ScrollPanel>
        </Dialog >

    );
}